import { render } from "./CanceledTomorrow.vue?vue&type=template&id=bc080d2c"
import script from "./CanceledTomorrow.vue?vue&type=script&lang=ts"
export * from "./CanceledTomorrow.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
